import styles from './popups.module.css'
import { useDispatch } from 'react-redux'
import { removeVendorStaff } from '../../features/vendorSlice'
import { ViewProfileRedirect } from './ViewProfileRedirect'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import ButtonCustom from '../atoms/button/ButtonCustom'

export const RemoveStaffPopup = ({ clickHandler, staff, open }) => {
	const dispatch = useDispatch()
	const handleRemove = () => {
		dispatch(removeVendorStaff(staff.staffId))
		clickHandler()
	}

	return (
		<CommonDeleteModal
			open={open}
			handleClose={clickHandler}
			heading={
				<>
					Remove&nbsp;
					{staff.staffId ? (
						<ViewProfileRedirect
							id={staff.staffId}
							name={staff.name}
						/>
					) : (
						<>{staff.email}</>
					)}
					&nbsp;from team?
				</>
			}
			subHeading={
				<>
					Removing this staff member will delete all the records
					associated with this account.
				</>
			}
			className={styles.deleteModal}
			ClassIcon={styles.detailModalIcon}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={clickHandler}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						data-cy="remove"
						variant="destructive"
						size="lg"
						onClick={handleRemove}
					>
						Remove
					</ButtonCustom>
				</>
			}
		></CommonDeleteModal>
	)
}
